<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row>
        <!-- 在QBR在In Plan和草稿状态，显示保存， -->
        <!-- 校验：如果QBR日期非空，校验计划月和QBR日期必须在同一个月。提示“计划月和QBR日期必须在同一个月” -->
        <!-- 如果状态为Delayed，判断计划月，如果计划月在当前或未来的月份，设置状态为In Plan -->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Save')" :disabled="detailForm.isDisabled" v-if="detailForm.planStatus!=='CANCEL'&&detailForm.planStatus!=='COMPLETED'&&!isRoles" v-acl="QSPI_QBR_SAVE">保存</el-button>
        <!-- 在QBR计划状态为非Cancel状态显示 如果QBR日期非空，校验计划月和QBR日期必须在同一个月-->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Start')" :disabled="detailForm.isDisabled" v-if="(detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&detailForm.qbrStatus=='DRAFT'&&!isRoles" v-acl="QSPI_QBR_GEN">发起QBR</el-button>
        <!-- 在QBR为非Cancel状态显示， -->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Cancle')" :disabled="detailForm.isDisabled" v-if="(detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&detailForm.qbrStatus!=='CLOSED'&&!isRoles" v-acl="QSPI_QBR_CANCEL">Cancel QBR</el-button>
        <!-- 在QBR为Cancel状态显示 -->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Recovery')" :disabled="detailForm.isDisabled" v-if="detailForm.planStatus=='CANCEL'&&!isRoles" v-acl="QSPI_QBR_RECOVER">恢复QBR</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onView">查看供应商历史表现</el-button>
        <!-- v-acl="QSPI_QBR_EXPORT_HIST_PERF" -->
        <!-- 供应商用户可见，在待供应商提交材料状态，In Plan显示 -->
        <!-- 校验：附件不能为空，附件的文件描述不能为空。提示“请上传附件”，“附件文件描述不能为空” -->
        <!-- isSup==='SUP'&& -->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Material')" :disabled="detailForm.isDisabled" v-if="((detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&detailForm.qbrStatus=='PENDING_BY_SUPPLIER'&&isRoles)||((detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&!isExsit)" v-acl="QSPI_QBR_ADD_DOC">提交材料</el-button>
        <!-- 供应商用户可见，在待补充材料 In Plan显示 -->
        <!-- 校验：附件不能为空，文件描述必填 -->
        <el-button size="mini" class="btn" type="primary" @click="onSave('Supplementary')" :disabled="detailForm.isDisabled" v-if="((detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&detailForm.qbrStatus=='PENDING_ATTACHMENT_BY_SUPPLIER'&&isRoles)||((detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&isExsit)" v-acl="QSPI_QBR_ADD_SUPP_DOC">提交补充材料</el-button>
        <!-- 待CQS评分，补充材料已提交状态显示 -->
        <!-- 校验：QBR Result，QBR日期不能为空。弹出补充材料窗口， -->
        <el-button size="mini" class="btn" type="primary" @click="onClose('Closed')" :disabled="detailForm.isDisabled" v-if="detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER'&&!isRoles" v-acl="QSPI_QBR_CLOSE">关闭QBR</el-button>
      </el-row>
      <div class="within_box">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">Basic Information</p>
        </div>
        <div class="form_box">
          <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="110px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="供应商集团名称" prop="groupName">
                  <el-input v-model="detailForm.groupName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Category2" prop="category2Name">
                  <el-input v-model="detailForm.category2Name" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="计划月" prop="month">
                  <el-date-picker v-model="detailForm.month" value-format="yyyy-MM" format="yyyy-MM" type="month" :disabled="isRoles||detailForm.isDisabled||detailForm.qbrStatus==='CLOSED'" clearable placeholder="选择月" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="计划状态" prop="planStatus">
                  <ic-select clearable table="TT_QSPI_QBR" field="PLAN_STATUS" v-model="detailForm.planStatus" disabled style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="QBR日期" prop="qbrDate">
                  <el-date-picker v-model="detailForm.qbrDate" :picker-options="pickerOptions" @change="qbrDateChange" type="date" value-format="yyyy-MM-dd" :disabled="isRoles||detailForm.isDisabled||detailForm.qbrStatus==='CLOSED'" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="材料提交截止日期" prop="deadline">
                  <el-date-picker v-model="detailForm.deadline" type="date" value-format="yyyy-MM-dd" :disabled="isRoles||detailForm.isDisabled||detailForm.qbrStatus==='CLOSED'" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="QBR状态" prop="qbrStatus">
                  <ic-select clearable table="TT_QSPI_QBR" field="QBR_STATUS" v-model="detailForm.qbrStatus" disabled style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="QBR Result" prop="result">
                  <ic-select clearable table="TT_QSPI_QBR" field="RESULT" v-model="detailForm.result" :disabled="isRoles||detailForm.isDisabled||(detailForm.qbrStatus!=='PENDING_BY_CQS'&&detailForm.qbrStatus!=='SUBMITTED_BY_SUPPLIER')" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="'备注 \n (供应商可见)'" prop="remarks">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" :disabled="isRoles||detailForm.isDisabled||(detailForm.qbrStatus!=='PENDING_BY_CQS'&&detailForm.qbrStatus!=='SUBMITTED_BY_SUPPLIER')" placeholder="请输入内容" v-model="detailForm.remarks"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="'补充材料备注 \n (供应商可见)'" prop="supplementaryRemarks">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" disabled placeholder="请输入内容" v-model="detailForm.supplementaryRemarks"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="!isRoles">
              <el-col :span="12">
                <el-form-item label="Talking Point" prop="talkingPoint">
                  <el-input type="textarea" maxlength="1000" :disabled="detailForm.isDisabled||detailForm.qbrStatus==='CLOSED'" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容" v-model="detailForm.talkingPoint"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="tab_box">
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="附件" name="tab1">
            <!-- <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file" v-if="detailForm.planStatus=='IN_PLAN'&&(detailForm.qbrStatus=='PENDING_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_ATTACHMENT_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&isRoles" v-acl="QSPI_QBR_UPLOAD_ATT,QSPI_QBR_ADD_DOC,QSPI_QBR_ADD_SUPP_DOC">
            <el-button slot="trigger" size="small" type="primary">{{$t('common.upload')}}</el-button>
          </el-upload> -->
            <el-button size="small" type="primary" @click="openFile" v-if="(detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&(detailForm.qbrStatus=='PENDING_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_ATTACHMENT_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&isRoles" v-acl="QSPI_QBR_UPLOAD_ATT,QSPI_QBR_ADD_DOC,QSPI_QBR_ADD_SUPP_DOC">选择文件</el-button>
            <el-table :data="fileData" border style="width: 100%">
              <el-table-column prop="documentName" label="附件名称">
                <template slot-scope="scope">
                  <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="附件描述" prop="docComments">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.docComments" placement="top-start">
                    <span style="display: inline-block;maxHeight: 80px;padding:10px 0px;box-sizing: border-box;">{{scope.row.docComments}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="userName" label="上传人"></el-table-column>
              <el-table-column prop="createDate" label="上传时间"></el-table-column>
              <el-table-column label="操作" width="80" v-if="(detailForm.planStatus=='IN_PLAN'||detailForm.planStatus=='DELAYED')&&(detailForm.qbrStatus=='PENDING_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_ATTACHMENT_BY_SUPPLIER'||detailForm.qbrStatus=='PENDING_BY_CQS'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&isRoles" v-acl="QSPI_QBR_UPLOAD_ATT,QSPI_QBR_ADD_DOC,QSPI_QBR_ADD_SUPP_DOC">
                <template slot-scope="scope">
                  <el-button @click="onDel(scope.row.tmDocumentId,scope.$index,fileData)" type="text" size="small" v-if="((detailForm.qbrStatus=='PENDING_BY_SUPPLIER'&&scope.row.tsReckindId === 'QSPI_QBR_FILE')||((detailForm.qbrStatus=='PENDING_ATTACHMENT_BY_SUPPLIER'||detailForm.qbrStatus=='SUBMITTED_BY_SUPPLIER')&&scope.row.tsReckindId === 'QSPI_QBR_FILE_AGAIN')||((detailForm.qbrStatus=='PENDING_BY_CQS')&&(scope.row.tsReckindId === 'QSPI_QBR_FILE_AGAIN'||scope.row.tsReckindId === 'QSPI_QBR_FILE')))&&(ms_userId===scope.row.createBy)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="tab2">
            <el-table ref="plxTable2" :data="workFlowLogList" max-height="500" border stripe highlight-current-row>
              <el-table-column align="center" label="操作时间" prop="createDate"></el-table-column>
              <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
              <el-table-column align="center" label="操作描述" prop="comments"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="上传附件" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <uploadFile v-if="dialogVisible" @close="handleClose" :tsRecId="tsRecId" :tsReckindId="tsReckindId"></uploadFile>
    </el-dialog>
    <el-dialog title="评分历史版本" :visible.sync="showDetailDialog" append-to-body width="70%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog"></detailDialog>
    </el-dialog>
    <el-dialog title="补充材料" :visible.sync="showFileDialog" append-to-body width="40%" :close-on-click-modal="false" @close="closeFileDialog">
      <el-form :model="supplementForm" ref="supplementForm" :rules="supplementFormRules" label-width="100px">
        <el-form-item label="需要补充材料" prop="supplementaryMaterials">
          <el-select v-model="supplementForm.supplementaryMaterials" clearable style="width:100%" placeholder="请选择">
            <el-option :key="index" v-for="(item,index) in supplementaryMaterialsList" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补充材料备注" prop="supplementaryRemarks">
          <el-input type="textarea" maxlength="100" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容" v-model="supplementForm.supplementaryRemarks"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onConfirm">确认</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import commonConstants from "@/constants/commonConstants";
import { Message } from "element-ui";
import detailDialog from './rateHistoryVersion.vue';
import IcSelect from "@/components/common/icSelect";
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
import uploadFile from './uploadFile.vue'
export default {
  name: 'qbrDetail',
  components: {
    detailDialog,
    IcSelect,
    uploadFile
  },
  data() {
    let validMonth = (rule, value, callback) => {
      if (!value) {
        this.$my_message('请选择计划月', 'error')
        callback(new Error(' '));
      } else {
        console.log('value', value);
        console.log('qbrDate', this.detailForm.qbrDate);
        if (this.detailForm.qbrDate) {
          var curYear = value.split('-')[0]
          var curMonth = value.split('-')[1]
          var qbrYear = this.detailForm.qbrDate.split('-')[0]
          var qbrMonth = this.detailForm.qbrDate.split('-')[1]
          if (curYear !== qbrYear || curMonth !== qbrMonth) {
            this.$my_message('计划月和QBR日期必须在同一个月份', 'error')
            callback(new Error(' '));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    let validQbrDate = (rule, value, callback) => {
      console.log('value', value);
      console.log('saveSubmit', this.saveSubmit);
      console.log('qbrDate', this.detailForm.month);
      if (this.saveSubmit == 'Closed' && !value) {
        this.$my_message('请选择QBR日期', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
      if (value && this.detailForm.month) {
        var curYear = value.split('-')[0]
        var curMonth = value.split('-')[1]
        var monthYear = this.detailForm.qbrDate.split('-')[0]
        var monthMonth = this.detailForm.qbrDate.split('-')[1]
        if (curYear !== monthYear || curMonth !== monthMonth) {
          this.$my_message('计划月和QBR日期必须在同一个月份', 'error')
          callback(new Error(' '));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validResult = (rule, value, callback) => {
      console.log('value', value);
      console.log('saveSubmit', this.saveSubmit);
      if (this.saveSubmit == 'Closed' && !value) {
        this.$my_message('请选择QBR Result', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    let validSupplementaryRemarks = (rule, value, callback) => {
      console.log('value', value);
      console.log('supplementaryMaterials', this.supplementForm.supplementaryMaterials);
      if (this.supplementForm.supplementaryMaterials == 'Y' && !value) {
        this.$my_message('请填写补充材料备注', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    let _this = this;
    return {
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      pickerOptions: {
        disabledDate(time) {
          var minTime = _this.$route.query.year + '-01-01'
          var maxTime = _this.$route.query.year + '-12-31'
          minTime = new Date(minTime).getTime() - 8.64e7
          maxTime = new Date(maxTime).getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      detailForm: {},
      supplementForm: {
        supplementaryMaterials: "",
        supplementaryRemarks: "",
      },
      rules: {
        month: [
          { required: true, validator: validMonth, trigger: 'change' }
        ],
        qbrDate: [
          { validator: validQbrDate, trigger: 'change' }
        ],
        result: [
          { validator: validResult, trigger: 'change' }
        ]
      },
      supplementFormRules: {
        supplementaryMaterials: [
          { required: true, message: "请选择需要补充材料", trigger: 'change' }
        ],
        supplementaryRemarks: [
          { validator: validSupplementaryRemarks, trigger: 'change' }
        ]
      },
      tableData: [],
      supplementFileList: [],
      fileData: [],
      workFlowLogList: [],
      supplementaryMaterialsList: [
        {
          label: "是",
          value: "Y"
        },
        {
          label: "否",
          value: "N"
        },
      ],
      showDetailDialog: false,
      showFileDialog: false,
      dialogVisible: false,
      month: this.$route.query.month,
      obj: {},
      id: null,
      ms_userId: null,
      isSup: false,
      isRoles: false,
      isExsit: true,
      saveSubmit: '',
      tsReckindId: null,
      tsRecId: null,
      activeName: "tab1",
    }
  },
  created() {
    this.isSup = localStorage.getItem('ms_emplFlag')
    let ms_roles = localStorage.getItem('ms_roles')
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    if (ms_roles.indexOf('QSPI_QBR_SUPP') !== -1) {
      this.isRoles = true
    } else {
      this.isRoles = false
    }
    console.log('isSup', this.isSup);
    console.log('isRoles', this.isRoles);
    if (this.$route.query.from == 'qbrPlan') {
      this.$set(this.obj, 'month', this.$route.query.month)
      this.$set(this.obj, 'ttQspiQbrPlanId', this.$route.query.ttQspiQbrPlanId)
    } else if (this.$route.query.from == 'todo') {
      this.$set(this.obj, 'month', this.$route.query.month)
      this.$set(this.obj, 'ttQspiQbrDetailId', this.$route.query.ttQspiQbrDetailId)
    } else {
      this.$set(this.obj, 'ttQspiQbrDetailId', this.$route.query.ttQspiQbrDetailId)
    }
    this.queryData()
  },
  mounted() {
  },
  methods: {
    queryData() {
      QBRApi.getQbrMaintainceDetail(this.obj).then(res => {
        console.log('qbr维护详情', res);
        this.id = res.data.records[0].ttQspiQbrDetailId
        this.detailForm = res.data.records[0]
        this.workFlowLogList = res.data.records[0].workFlowLogList
        this.getFileLists(res.data.records[0].ttQspiQbrDetailId)
      });
    },
    handleClose() {
      this.dialogVisible = false
      this.getFileLists(this.id)
    },
    openFile() {
      if (this.detailForm.qbrStatus === 'PENDING_BY_SUPPLIER' || ((this.detailForm.qbrStatus === 'PENDING_BY_CQS' || this.detailForm.qbrStatus === 'SUBMITTED_BY_SUPPLIER') && !this.isExsit)) {
        this.tsReckindId = "QSPI_QBR_FILE";
      }
      if (this.detailForm.qbrStatus === 'PENDING_ATTACHMENT_BY_SUPPLIER' || ((this.detailForm.qbrStatus === 'PENDING_BY_CQS' || this.detailForm.qbrStatus === 'SUBMITTED_BY_SUPPLIER') && this.isExsit)) {
        this.tsReckindId = "QSPI_QBR_FILE_AGAIN";
      }
      this.tsRecId = this.id
      this.dialogVisible = true
    },
    getFileLists(ttQspiQbrDetailId) {
      QBRApi.getFileLists({
        seq: '1',
        tsReckindIdList: ["QSPI_QBR_FILE", "QSPI_QBR_FILE_AGAIN"],
        tsRecId: ttQspiQbrDetailId
      }).then(res => {
        console.log('获取列表', res);
        this.fileData = res
        this.isExsit = this.fileData.some(ele => {
          return ele.tsReckindId === 'QSPI_QBR_FILE_AGAIN'
        })
      });
    },
    onSave(type) {
      this.$set(this.detailForm, 'type', type)
      this.saveSubmit = type
      if ((type === 'Material' || type === 'Supplementary') && this.fileData.length === 0) {
        this.$message.error('请上传附件')
        return;
      }
      if (type === 'Supplementary') {
        var flag = this.fileData.some(ele => {
          return ele.tsReckindId === 'QSPI_QBR_FILE_AGAIN'
        })
        if (!flag) {
          this.$message.error('请提交补充材料')
          return;
        }
      }
      this.sendReq(type)
    },
    onClose(type) {
      this.$set(this.detailForm, 'type', type)
      this.saveSubmit = type
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          this.showFileDialog = true
        }
      })
    },
    sendReq(type) {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          QBRApi.saveQbr(this.detailForm).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              switch (type) {
                case 'Save':
                  this.$message.success('保存成功')
                  break;
                case 'Start':
                  this.$message.success('发起QBR成功')
                  break;
                case 'Cancle':
                  this.$message.success('Cancel QBR成功')
                  break;
                case 'Recovery':
                  this.$message.success('恢复QBR成功')
                  break;
                case 'Material':
                  this.$message.success('提交材料成功')
                  break;
                case 'Supplementary':
                  this.$message.success('提交补充材料成功')
                  break;
                case 'Closed':
                  this.$message.success('操作成功')
                  break;
              }
              this.$router.go(-1)
            } else {
              this.$message.error(res.meta.msg)
            }
          });
        }
      })
    },
    onDel(tmDocumentId, index, files) {
      if (tmDocumentId) {
        fileService.deleteFile(tmDocumentId).then((res) => {
          if (res.code === '200') {
            files.splice(index, 1);
          }
        })
      } else {
        //还没保存
        files.splice(index, 1);
      }
    },
    onDownload(row) {
      console.log('row', row);
      fileService.downloadFile(row).then((res) => {
        console.log('res', res);
      })
    },
    onConfirm() {
      if (this.supplementForm.supplementaryMaterials == 'Y') {
        this.$set(this.detailForm, 'isSupplementary', true)
      } else {
        this.$set(this.detailForm, 'isSupplementary', false)
      }
      this.$refs['supplementForm'].validate((valid) => {
        if (valid) {
          this.$set(this.detailForm, 'supplementaryRemarks', this.supplementForm.supplementaryRemarks)
          this.sendReq(this.saveSubmit)
          this.showFileDialog = false
        }
      })
    },
    qbrDateChange(val) {
      console.log('val', val.split('-'));
      var y = val.split('-')[0]
      var m = val.split('-')[1]
      if (val) {
        this.$set(this.detailForm, 'month', y + '-' + m)
      }
    },
    uploadConfirm(item) {
      console.log('item', item);
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      //调用成功后调用后台方法进行文件关系维护
      fileService.fileUpload(formData).then(res => {
        console.log('666', res);
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data[0];
        attachment.tsRecId = this.id;
        // 或者qbr状态待CQS评分,并且文件中不存在again类型的附件
        if (this.detailForm.qbrStatus === 'PENDING_BY_SUPPLIER' || ((this.detailForm.qbrStatus === 'PENDING_BY_CQS' || this.detailForm.qbrStatus === 'SUBMITTED_BY_SUPPLIER') && !this.isExsit)) {
          attachment.tsReckindId = "QSPI_QBR_FILE";
        }
        if (this.detailForm.qbrStatus === 'PENDING_ATTACHMENT_BY_SUPPLIER' || ((this.detailForm.qbrStatus === 'PENDING_BY_CQS' || this.detailForm.qbrStatus === 'SUBMITTED_BY_SUPPLIER') && this.isExsit)) {
          attachment.tsReckindId = "QSPI_QBR_FILE_AGAIN";
        }
        fileService.saveFile(attachment).then(saveRes => {
          console.log('555', saveRes);
          _this.getFileLists(this.id);
        });
      }).catch(error => {
        console.log('error', error);
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    onView() {
      const host = window.location.href.split("#")[0];
      console.log('host', host);
      var url = `${host}#/qspiQBR/rateHistoryVersion/?groupCode=${this.detailForm.groupCode}`;
      console.log('url', url);
      window.open(url, '_blank')
      // this.$router.push({
      //   path: '/qspiQBR/rateHistoryVersion',
      //   query: {
      //     groupCode: this.detailForm.groupCode
      //   }
      // })
    },
    routerBack() {
      this.$router.back();
    },
    closeDialog() {
      this.showDetailDialog = false
    },
    closeFileDialog() {
      this.showFileDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>